import { Heading } from "@chakra-ui/react";
//assets
// import Cancel from "assets/svg/other/cancel.svg";
// import User from 'assets/svg/icons-new/user.png'
// import Load from "assets/svg/other/loading2.svg";
import Close from "@material-ui/icons/Close";
import Back from "assets/svg/back-arrow.svg";
import Arrow from "assets/svg/icons-new/arrow.svg";
// import Bank from "assets/svg/icons-new/banks.svg";
// import Edit from "assets/svg/icons-new/edit.svg";
//import Support from 'assets/svg/icons-new/support.svg'
//import Logout from 'assets/svg/icons-new/logout.svg';
// import Refer from "assets/svg/icons-new/refer.svg";
import Header from "components/dashHeader";
// import ProfileShortInfo from "components/ProfileShortInfo/ProfileShortInfo";
import AccountSidebar from "components/AccountSidebar/AccountSidebar";
// components
import Sidemenu from "components/sidemenu";
// import SupportBox from "components/support";
import Toggle2FA from "components/Toggle2FA/Toggle2FA";
//css
import "pages/styles/dashboard/Account.css";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { get, post, put } from "util/axiosLib";
import { logger } from "util/logger";
// import VerificationIcon from "../../../assets/svg/verification.svg";

export default class AccountEdit extends Component {
  state = {
    tab: "personal",
    unVerifiedShow: true,
    personalSection: true,
    securitySection: false,
    changePassword: false,
    resetPinSection: false,
    changePinSection: false,
    createPinSection: false,
    currentUser: undefined,
    currentSecuritySection: "",
    resetCode: undefined,
    //cPStatus:false,
    userData: "",
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
    passwordError: "",
    otherError: "",
    saveChangesLoading: false,
    pinSubmitLoading: false,
    pinError: "",
    twofastatus: undefined,
  };

  componentDidMount() {
    this.token = this.props.token;

    try {
      const cPStatus = localStorage.getItem("changePinStatus");

      this.setState({
        userData: this.props.userData,
        firstName: this.props.userData.firstName,
        lastName: this.props.userData.lastName,
        phone: this.props.userData.phone,
        email: this.props.userData.email,
        country: this.props.userData.country,
        username: this.props.userData.username,
        // twofastatus: this.props.userData.twofastatus,

        cPStatus,
      });

      // this.setState({
      //   currentUser: userData,
      //   twofastatus: getUserReq.data.data.twoFactor,
      // });

      if (cPStatus === "true") {
        this.setState({
          personalSection: false,
          securitySection: false,
          changePassword: false,
          pinSection: true,
        });
      }
    } catch (err) {}
  }

  updateUserData = async () => {
    try {
      const token = this.token;

      const headers = {
        "Content-Type": "application/json",
        authorization: `${token}`,
      };

      const updatedUser = await get(
        `${process.env.REACT_APP_API_ENDPOINT}/auth/currentUser`,
        headers
      );

      const userData = JSON.stringify(updatedUser?.data?.data);
      localStorage.setItem("btm_user", userData);
      this.setState({ userData: updatedUser?.data.data });
    } catch (err) {}
  };

  handlePersonal = (event) => {
    event.preventDefault();

    this.setState({
      tab: "personal",
      // personalSection: true,
      // securitySection: false,
      // changePassword: false,
      // pinSection: false,
      passwordError: "",
      successMsg: "",
      incorrectError: "",
      // cPStatus: false,
    });
  };

  handleSecurity = (event) => {
    event.preventDefault();

    this.setState({
      tab: "security",
      currentSecuritySection: "",
      passwordError: "",
      successMsg: "",
      incorrectError: "",
    });
  };

  changePasswordView = (event) => {
    event && event.preventDefault();

    this.setState({
      currentSecuritySection: "changePassword",
    });
  };

  handlePin = (event) => {
    event.preventDefault();

    this.setState({
      currentSecuritySection: "changePin",
    });
  };

  changePinView = (event) => {
    event.preventDefault();

    this.setState({
      currentSecuritySection: "changePin",
    });
  };

  createPinView = (event) => {
    event.preventDefault();

    this.setState({
      currentSecuritySection: "createPin",
    });
  };

  resetPinView = (event) => {
    event.preventDefault();

    this.setState({
      currentSecuritySection: "resetPin",
    });
  };

  // state = initialState;

  // Change password Input Validation

  validatePassword = () => {
    let passwordError = "";

    const passwordRegex = /(?=.*[0-9])/;

    if (this.state.newPassword !== this.state.confirmPassword) {
      const element = document.getElementById("pass");
      const element2 = document.getElementById("pass2");
      element.classList.add("inputs-error");
      element2.classList.add("inputs-error");
      passwordError = "Passwords don't match!";
    } else {
      const element = document.getElementById("pass");
      const element2 = document.getElementById("pass2");
      element.classList.remove("inputs-error");
      element2.classList.remove("inputs-error");
      // passwordError = " "
    }
    if (this.state.newPassword.length < 7) {
      const element = document.getElementById("pass");
      element.classList.add("inputs-error");
      passwordError = "Password must be at least 7 characters long!";
    } else {
      const element = document.getElementById("pass");
      element.classList.remove("inputs-error");
      // passwordError = " "
    }
    if (!passwordRegex.test(this.state.newPassword)) {
      const element = document.getElementById("pass");
      element.classList.add("inputs-error");
      passwordError = "Password should contain a number!";
    } else {
      const element = document.getElementById("pass");
      element.classList.remove("inputs-error");
      // passwordError = " "
    }

    if (passwordError) {
      this.setState({ passwordError });
      return false;
    }

    return true;
  };

  // Change Password
  handleChangePassword = async (event) => {
    event.preventDefault();

    try {
      const isValid = this.validatePassword();
      if (isValid) {
        // load gif
        // const loaded = document.getElementById("load");
        // loaded?.classList?.add("load-gif-on2");
        this.setState({
          saveChangesLoading: true,
        });

        const token = this.token;

        const headers = {
          authorization: `${token}`,
          "Content-Type": "application/json",
        };
        const passwordUpdate = {
          oldPassword: this.state.currentPassword,
          password: this.state.newPassword,
          confirmPassword: this.state.newPassword,
        };

        console.log(passwordUpdate, "UPDATE PASSWORD");

        const passwordReq = await put(
          `${process.env.REACT_APP_API_ENDPOINT}/account/changePassword`,
          passwordUpdate,
          headers
        );

        if (passwordReq.data.status === "success") {
          this.setState({
            successMsg: "Password successfully updated.",
            incorrectError: " ",
            saveChangesLoading: false,
          });
        }
        console.log(passwordReq.data, "PASSWORD REQUEST 2");

        // load gif remove
        // loaded?.classList?.remove("load-gif-on2");

        const message = document.getElementById("successmsg");
        setTimeout(() => {
          message.classList.add("message-off");
        }, 2500);

        logger(passwordReq.data);
      }
    } catch (err) {
      logger("update ERROR::: ", err);
      if (err.isAxiosError) {
        const errData = err.response;

        // const loaded = document.getElementById("load");
        // loaded?.classList?.remove("load-gif-on2");
        this.setState({
          saveChangesLoading: false,
        });

        if (errData?.status === 403 || errData?.status === 401) {
          const errmsg = document.getElementById("error-info2");
          errmsg.classList.add("err-auth-on");
          this.setState({ tokenError: "Token expired, please login again." });

          setTimeout(() => {
            window.location = "/";
          }, 2000);
        }
        if (errData?.status === 400) {
          this.setState({
            incorrectError:
              "Pls check that your current password was correctly entered",
          });
        }

        // const message = document.getElementById("errormsg");
        // setTimeout(() => {
        //   message.classList.add("message-off");
        // }, 2000);
      }
    }
  };

  // Update user details

  handleUserUpdate = async (event) => {
    try {
      event.preventDefault();

      // load gif
      const loaded = document.getElementById("load");
      loaded?.classList?.add("load-gif-on2");

      this.setState({ successMsg: " " });

      const token = this.token;

      const headers = {
        "Content-Type": "application/json",
        authorization: `${token}`,
      };

      // User details
      const userDetails = {
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        username: this.state.username,
        phone: this.state.phone,
        email: this.state.email,
        country: this.state.country,
      };

      // update request
      const updateReq = await put(
        `${process.env.REACT_APP_API_ENDPOINT}/account/updateProfile`,
        userDetails,
        headers
      );

      // load gif remove
      loaded?.classList?.remove("load-gif-on2");

      this.setState({
        successMsg: "Details successfully updated.",
        incorrectError: " ",
      });

      const message = document.getElementById("successmsg");
      setTimeout(() => {
        message.classList.add("message-off");
        window.location = "/dashboard/accountedit";
      }, 2500);

      logger(updateReq.data);
    } catch (err) {
      logger("update ERROR::: ", err);
      if (err.isAxiosError) {
        const errData = err.response;

        const loaded = document.getElementById("load");
        loaded?.classList?.remove("load-gif-on");

        this.setState({ incorrectError: errData.data.error });

        if (errData?.status === 403 || errData?.status === 401) {
          const errmsg = document.getElementById("error-info2");
          errmsg.classList.add("err-auth-on");
          this.setState({ tokenError: "Token expired, please login again." });

          setTimeout(() => {
            window.location = "/";
          }, 2000);
        }
      } else {
        this.setState({ otherError: "Something went wrong" });
      }
    }
  };

  enable2FA = async () => {
    try {
      // load gif
      const loaded = document.getElementById("load");
      loaded?.classList?.add("load-gif-on2");

      this.setState({ successMsg: " " });

      const token = this.token;

      const headers = {
        "Content-Type": "application/json",
        authorization: `${token}`,
      };

      const enable = {};

      const enableReq = await put(
        `${process.env.REACT_APP_API_ENDPOINT}/auth/2fa/turnOnTwoFa`,
        enable,
        headers
      );

      logger(enableReq);

      this.setState({ successMsg: "Two Factor enabled" });

      setTimeout(() => {
        window.location.reload();
      }, 2500);

      //const loaded = document.getElementById("load");
      loaded?.classList?.remove("load-gif-on2");
    } catch (err) {
      if (err.isAxiosError) {
        const errData = err.response;

        const loaded = document.getElementById("load");
        loaded?.classList?.remove("load-gif-on");

        this.setState({ incorrectError: errData.data.error });
      }
    }
  };

  disable2FA = async () => {
    try {
      // load gif
      const loaded = document.getElementById("load");
      loaded?.classList?.add("load-gif-on2");

      this.setState({ successMsg: " " });

      const token = this.token;

      const headers = {
        "Content-Type": "application/json",
        authorization: `${token}`,
      };

      const disable = {};

      const disableReq = await put(
        `${process.env.REACT_APP_API_ENDPOINT}/auth/2fa/turnOffTwoFa`,
        disable,
        headers
      );
      this.setState({ successMsg: "Two Factor disabled" });
      setTimeout(() => {
        window.location.reload();
      }, 2500);
      logger(disableReq);
      loaded?.classList?.remove("load-gif-on2");
    } catch (err) {
      if (err.isAxiosError) {
        const errData = err.response;

        const loaded = document.getElementById("load");
        loaded?.classList?.remove("load-gif-on");

        this.setState({ incorrectError: errData.data.error });
      }
    }
  };

  validatePin = () => {
    let passwordError = "";

    const passwordRegex = /(?=[a-zA-Z])/;

    if (this.state.newPin !== this.state.confirmPin) {
      const element = document.getElementById("pin");
      const element2 = document.getElementById("pin2");
      element && element.classList.add("inputs-error");
      element2 && element2.classList.add("inputs-error");
      passwordError = "Pins don't match!";
    } else {
      const element = document.getElementById("pin");
      const element2 = document.getElementById("pin2");
      element && element.classList.remove("inputs-error");
      element2 && element2.classList.remove("inputs-error");
      // passwordError = " "
    }
    if (this.state.newPin.length < 5) {
      const element = document.getElementById("pin");
      element && element.classList.add("inputs-error");
      passwordError = "Pin must be 6 digit long";
    } else {
      const element = document.getElementById("pin");
      element.classList.remove("inputs-error");
      // passwordError = " "
    }
    if (passwordRegex.test(this.state.newPin)) {
      const element = document.getElementById("pin");
      element && element.classList.add("inputs-error");
      passwordError = "Pin should contain only numbers!";
    } else {
      const element = document.getElementById("pin");
      element && element.classList.remove("inputs-error");
      // passwordError = " "
    }

    if (passwordError) {
      this.setState({ passwordError });
      return false;
    } else {
      this.setState({
        passwordError: "",
      });
    }

    return true;
  };

  handleCreatePinSubmit = async (event) => {
    event.preventDefault();

    try {
      const isValid = this.validatePin();
      if (isValid) {
        // load animation
        const loaded = document?.getElementById("load");
        loaded?.classList?.add("load-gif-on2");

        this.setState({
          pinSubmitLoading: true,
        });

        this.setState({ successMsg: " ", passwordError: "", otherError: "" });

        // const token = localStorage.getItem("tokenset");

        const headers = {
          "Content-Type": "application/json",
          authorization: `${this.token}`,
        };
        const pinInfo = {
          pin: this.state.newPin,
          confirmPin: this.state.newPin,
        };

        console.log("PIN REQUEST", pinInfo);

        const response = await put(
          `${process.env.REACT_APP_API_ENDPOINT}/account/pin`,
          pinInfo,
          headers
        );

        if (response) {
          console.log(response, "RESSSPONSE");

          this.setState({
            pinSubmitLoading: false,
          });
        }

        this.setState({ successMsg: "Pin created successfully" }, () => {
          this.updateUserData();
          setTimeout(() => this.setState({ currentSecuritySection: "" }), 1200);
        });
        loaded?.classList?.remove("load-gif-on2");
      }
    } catch (err) {
      this.setState({
        pinSubmitLoading: false,
        pinError: err.error,
      });
      console.log("update ERROR::: ", err);
      if (err.isAxiosError) {
        const errData = err.response;

        const loaded = document?.getElementById("load");
        loaded?.classList?.remove("load-gif-on2");

        this.setState({ incorrectError: String(errData?.data?.error) });
      }
    }
  };

  handleChangePinSubmit = async (event) => {
    try {
      event && event.preventDefault();
      const isValid = this.validatePin();
      if (isValid) {
        // load animation
        const loaded = document.getElementById("load");
        loaded?.classList?.add("load-gif-on2");

        this.setState({ successMsg: " " });

        // const token = localStorage.getItem("tokenset");

        const headers = {
          "Content-Type": "application/json",
          authorization: `${this.token}`,
        };

        const pinInfo = {
          oldPin: this.state.currentPin,
          newConfirmPin: this.state.newPin,
          newPin: this.state.newPin,
        };

        await put(
          `${process.env.REACT_APP_API_ENDPOINT}/account/changePin`,
          pinInfo,
          headers
        );

        this.setState({ successMsg: "Pin updated successfully" }, () => {
          this.updateUserData();
          setTimeout(() => this.setState({ currentSecuritySection: "" }), 1200);
        });

        loaded?.classList?.remove("load-gif-on2");
      }
    } catch (err) {
      console.log("update ERROR::: ", err);
      if (err.isAxiosError) {
        const errData = err.response;

        const loaded = document.getElementById("load");
        loaded?.classList?.remove("load-gif-on2");

        this.setState({ incorrectError: errData.data.error });
      }
    }
  };

  getPinResetCode = async (event) => {
    try {
      event.preventDefault();
      const isValid = this.validatePin();
      if (isValid) {
        // load animation
        const loaded = document.getElementById("load");
        loaded?.classList?.add("load-gif-on2");

        this.setState({
          successMsg: "",
          incorrectError: "",
          passwordError: "",
        });

        // const token = localStorage.getItem("tokenset");

        const headers = {
          "Content-Type": "application/json",
          authorization: `${this.token}`,
        };

        const hasExistingPin = this.state.userData.txPin;
        if (hasExistingPin) {
          await post(
            `${process.env.REACT_APP_API_ENDPOINT}/account/resetPinVerificationCode`,
            {},
            headers
          );

          this.setState({
            successMsg: ``,
            currentSecuritySection: "confirmResetPin",
          });
        } else {
          this.setState({
            currentSecuritySection: "",
          });
        }
        loaded?.classList?.remove("load-gif-on2");
      }
    } catch (err) {
      console.log("reset code ERROR::: ", err);
      if (err.isAxiosError) {
        const errData = err.response;

        const loaded = document.getElementById("load");
        loaded?.classList?.remove("load-gif-on2");

        this.setState({
          incorrectError: errData?.data?.error
            ? String(errData?.data?.error)
            : String(errData),
        });
      }
    }
  };

  handleResetPinSubmit = async (event) => {
    try {
      event.preventDefault();
      if (!this.state.resetCode)
        return this.setState({
          incorrectError: "Reset verification code is required",
        });
      this.setState({ successMsg: "", incorrectError: "", passwordError: "" });
      const isValid = this.validatePin();
      if (isValid) {
        // load animation
        const loaded = document.getElementById("load");
        loaded && loaded?.classList?.add("load-gif-on2");

        this.setState({ successMsg: " " });

        // const token = localStorage.getItem("tokenset");

        const headers = {
          "Content-Type": "application/json",
          authorization: `${this.token}`,
        };

        const hasExistingPin = this.state.userData.txPin;
        if (hasExistingPin) {
          const pinInfo = {
            newPin: this.state.newPin,
            confirmPin: this.state.newPin,
            newConfirmPin: this.state.newPin,
            resetCode: this.state.resetCode,
          };

          await put(
            `${process.env.REACT_APP_API_ENDPOINT}/account/resetPin`,
            pinInfo,
            headers
          );

          this.setState({ successMsg: "Pin reset successfully" }, () => {
            setTimeout(
              () => this.setState({ currentSecuritySection: "" }),
              1200
            );
          });
        } else {
          this.setState({ incorrectError: "Cannot reset a non-existing pin." });
        }
        loaded && loaded?.classList?.remove("load-gif-on2");
      }
    } catch (err) {
      console.log("update ERROR::: ", err);
      if (err.isAxiosError) {
        const errData = err?.response;

        const loaded = document.getElementById("load");
        loaded && loaded?.classList?.remove("load-gif-on2");

        this.setState(
          { incorrectError: String(errData?.data?.error?.newPin ?? "") },
          this.updateUserData
        );
      }
    }
  };

  render() {
    const currentPage = "Account";
    const currentUser = this.state.currentUser;
    const userHasPin = currentUser?.hasPin || this.state.userData?.txPin;
    const activeTab = this.state.tab;
    const activeSection = this.state.currentSecuritySection;

    return (
      <div>
        <Sidemenu currentPage={currentPage} logoutUser={this.props.logout} />
        <Header />
        <section>
          <div className="account-container">
            {/* {this.state.unVerifiedShow ? (
              <div className="home-verifywarn-m">
                <p className="h-v-m"> You need to verify your account </p>
                <Link to="/dashboard/accountverify" className="verify-m h-v-m">
                  <p>Verify now</p>
                </Link>
              </div>
            ) : null} */}

            <div className="account-content">
              <div className="account-top">
                <Heading className="b-header">Account</Heading>
                <Link className="m-header" to="/dashboard/account">
                  <img src={Back} className="w-backarrow" alt="back" />
                </Link>
                <h1 className="m-header"> Edit Profile </h1>
              </div>
              <div className="account-nav animate__animated animate__fadeInDown">
                <Link to="/dashboard/account" className="right-e">
                  <p className="ash"> Account </p>{" "}
                </Link>
                <img className="right-e" src={Arrow} alt="" />
                <p>
                  <span className="bold">Edit Profile</span>
                </p>
              </div>
              <div className="account-sections">
                <div className="account-section-left section-hide">
                  <div className="asl-content">
                    {/* <div className="asl-profile-box">
                      <ProfileShortInfo
                        fullName={this.state?.userData?.fullName}
                        verified={this.state?.userData?.verified}
                        kycLevel={this.state?.userData?.kycLevel}
                      />
                    </div> */}
                    <div className="asl-actions">
                      <AccountSidebar
                        current="edit"
                        userData={this.props.userData}
                        logout={this.props.logout}
                      />
                      {/* <Link
                        to="/dashboard/accountedit"
                        className="asl-action-single asl-active"
                      >
                        <div className="asl-action-desc">
                          <img className="right-m2" src={Edit} alt="edit" />
                          <p>Edit Profile </p>
                        </div>
                        <div className="asl-action-arrow">
                          <img src={Arrow} alt="arrow" />
                        </div>
                      </Link> */}
                      {/* <Link
                        to="/dashboard/accountbanks"
                        className="asl-action-single"
                      >
                        <div className="asl-action-desc">
                          <img className="right-m2" src={Bank} alt="edit" />
                          <p>Banks and Cards </p>
                        </div>
                        <div className="asl-action-arrow">
                          <img src={Arrow} alt="arrow" />
                        </div>
                      </Link> */}
                      {/* <Link
                        to="/dashboard/accountVerification"
                        className="asl-action-single"
                      >
                        <div className="asl-action-desc">
                          <img
                            className="right-m2"
                            src={VerificationIcon}
                            alt="edit"
                          />
                          <p>Verification</p>
                        </div>
                        <div className="asl-action-arrow">
                          <img src={Arrow} alt="arrow" />
                        </div>
                      </Link> */}

                      {/* <Link to="/dashboard/accountbvn" className="asl-action-single">
                            <div className="asl-action-desc">
                                <img className="right-m2" src={Bvn} alt="edit"/>
                                <p> BVN </p>
                            </div>
                            <div className="asl-action-arrow">
                                <img src={Arrow} alt="arrow" />
                            </div>
                        </Link> */}
                      {/* <div className="asl-action-single disable-temp">
                        <div className="asl-action-desc">
                          <img className="right-m2" src={Bvn} alt="edit" />
                          <p> BVN </p>
                        </div>
                        <div className="asl-action-arrow">
                          <img src={Arrow} alt="arrow" />
                        </div>
                      </div> */}

                      {/* <Link
                        to="/dashboard/accountrefer"
                        className="asl-action-single"
                      >
                        <div className="asl-action-desc">
                          <img className="right-m2" src={Refer} alt="edit" />
                          <p>Refer a friend </p>
                        </div>
                        <div className="asl-action-arrow">
                          <img src={Arrow} alt="arrow" />
                        </div>
                      </Link> */}
                      {/* <SupportBox /> */}
                      {/* <Link to="/" className="asl-action-single">
                        <div className="asl-action-desc">
                          <img className="right-m2" src={Logout} alt="edit" />
                          <p>Log out </p>
                        </div>
                      </Link> */}
                    </div>
                  </div>
                </div>
                <div
                  id="error-info2"
                  className="err-auth zindex animate__animated animate__slideInDown"
                >
                  <p>
                    <strong>{this.state.tokenError}</strong>
                  </p>
                </div>
                <div className="account-section-right animate__animated animate__fadeIn">
                  {/* the tabs --- PERSONAL | SECURITY ----- */}
                  <div className="asr-edit">
                    {/* <div className="asr-edit-image-box">
                          <div className="asr-profile-img">
                              <img src={User} alt="user" />
                          </div>
                          <div className="asr-profile-info">
                              <p> Tap to change picture </p>
                          </div>
                      </div> */}
                    <div className="asr-tabs">
                      <div
                        onClick={this.handlePersonal}
                        className={
                          activeTab === "personal"
                            ? "asr-tab-single active-tab"
                            : `asr-tab-single `
                        }
                      >
                        <p>Personal</p>
                      </div>
                      <div
                        onClick={this.handleSecurity}
                        className={
                          activeTab === "security"
                            ? "asr-tab-single active-tab"
                            : `asr-tab-single `
                        }
                      >
                        <p>Security</p>
                      </div>
                    </div>

                    <div className="asr-edit-content">
                      {activeTab === "personal" && (
                        <form
                          className="asr-edit-form"
                          onSubmit={this.handleUserUpdate}
                        >
                          <div className="asr-edit-input">
                            <input
                              type="text"
                              placeholder="First name"
                              defaultValue={this.state.firstName}
                              onChange={(e) =>
                                this.setState({ firstName: e.target.value })
                              }
                              disabled
                            />
                          </div>
                          <div className="asr-edit-input">
                            <input
                              type="text"
                              placeholder="Last name"
                              defaultValue={this.state.lastName}
                              onChange={(e) =>
                                this.setState({ lastName: e.target.value })
                              }
                              disabled
                            />
                          </div>
                          <div className="asr-edit-input">
                            <input
                              type="text"
                              placeholder="Username"
                              defaultValue={this.state.username}
                              onChange={(e) =>
                                this.setState({ username: e.target.value })
                              }
                              disabled
                            />
                          </div>
                          <div className="asr-edit-input">
                            <input
                              type="email"
                              placeholder="Email address"
                              defaultValue={this.state.email}
                              onChange={(e) =>
                                this.setState({ email: e.target.value })
                              }
                              disabled
                            />
                          </div>
                          <div className="asr-edit-input">
                            <input
                              type="text"
                              placeholder="Phone number"
                              defaultValue={this.state.phone}
                              onChange={(e) =>
                                this.setState({ phone: e.target.value })
                              }
                              disabled
                            />
                          </div>
                          <div className="asr-edit-input ">
                            <select
                              style={{
                                border: "1px solid green",
                                cursor: "pointer",
                              }}
                              onChange={(e) =>
                                this.setState({ country: e.target.value })
                              }
                              defaultValue={this.state.country}
                              disabled
                            >
                              <option selected value={this.state.country}>
                                {this.state.country}
                              </option>
                              {this.state.country === "Nigeria" && (
                                <option value="Ghana">Ghana</option>
                              )}
                              {this.state.country === "Ghana" && (
                                <option value="Nigeria">Nigeria</option>
                              )}
                            </select>
                          </div>
                          {/* <div className="asr-edit-input">
                            <button className="asr-edit-btn" type="submit">
                              {" "}
                              Update{" "}
                            </button>
                          </div> */}
                          {/* <div className="load-gif2" id="load">
                            <img src={Load} alt="loading" />
                          </div> */}
                          <p className="errormsg3">
                            {this.state.incorrectError}
                          </p>
                          <p className="errormsg3">{this.state.otherError}</p>
                          <p className="successmsg2" id="successmsg">
                            {this.state.successMsg}
                          </p>
                        </form>
                      )}

                      {activeTab === "security" && (
                        <>
                          {!activeSection && (
                            <div className="asr-security-btns">
                              <div
                                onClick={this.changePasswordView}
                                className="asr-sb-single"
                              >
                                <div className="asr-sb-desc">
                                  <p>Change Password </p>
                                </div>
                                <div className="asr-sb-arrow">
                                  <img src={Arrow} alt="arrow" />
                                </div>
                              </div>
                              {userHasPin && (
                                <>
                                  <div
                                    onClick={this.changePinView}
                                    className="asr-sb-single"
                                  >
                                    <div className="asr-sb-desc">
                                      <p>Update Pin</p>
                                    </div>
                                    <div className="asr-sb-arrow">
                                      <img src={Arrow} alt="arrow" />
                                    </div>
                                  </div>
                                  <div
                                    onClick={this.resetPinView}
                                    className="asr-sb-single"
                                  >
                                    <div className="asr-sb-desc">
                                      <p>Reset Pin</p>
                                    </div>
                                    <div className="asr-sb-arrow">
                                      <img src={Arrow} alt="arrow" />
                                    </div>
                                  </div>
                                </>
                              )}
                              {!userHasPin && (
                                <div
                                  onClick={this.createPinView}
                                  className="asr-sb-single"
                                >
                                  <div className="asr-sb-desc">
                                    <p>Create Pin</p>
                                  </div>

                                  <div className="asr-sb-arrow">
                                    <img src={Arrow} alt="arrow" />
                                  </div>
                                </div>
                              )}

                              {/* <div
                                className="asr-sb-single"

                              >
                                <Link to="/2faenter">
                                  <div className="asr-sb-desc">
                                    <p>Two-factor Authentication </p>
                                  </div>
                                </Link>

                                <div className="asr-sb-arrow">
                                  {twoFactor === true && (
                                    <label className="switch-toggle">
                                      <input
                                        onChange={this.disable2FA}
                                        type="checkbox"
                                        name="2fa"
                                        defaultChecked
                                      />
                                      <span className="slider-toggle round"></span>
                                    </label>
                                  )}
                                  {twoFactor === false && (
                                    <label className="switch-toggle">
                                      <input
                                        onChange={this.enable2FA}
                                        type="checkbox"
                                        name="2fa"
                                      />
                                      <span className="slider-toggle round"></span>
                                    </label>
                                  )}

                                </div>
                              </div> */}

                              <Toggle2FA
                                token={this.token}
                                userData={this.props.userData}
                              />
                              {/* <div className="load-gif2" id="load">
                                <img src={Load} alt="loading" />
                              </div> */}
                              <p className="successmsg2" id="successmsg">
                                {this.state.successMsg}
                              </p>
                              <p className="errormsg3" id="errormsg">
                                {this.state.incorrectError}
                              </p>
                              <p className="errormsg3">
                                {this.state.otherError}
                              </p>
                            </div>
                          )}

                          {activeSection === "changePassword" && (
                            <>
                              <p
                                style={{
                                  marginRight: "0.5rem",
                                  marginTop: "0.5rem",
                                  cursor: "pointer",
                                  display: "flex",
                                  justifyContent: "flex-end",
                                }}
                                onClick={this.handleSecurity}
                              >
                                <Close />
                              </p>
                              <form
                                id="cp-toggle"
                                className="asr-edit-form animate__animated animate__fadeIn"
                                onSubmit={this.handleChangePassword}
                              >
                                <div className="asr-edit-input">
                                  <input
                                    type="password"
                                    placeholder="Current Password"
                                    id="pass"
                                    onChange={(e) =>
                                      this.setState({
                                        currentPassword: e.target.value,
                                      })
                                    }
                                    required
                                  />
                                </div>
                                {/* <p className="errormsg">{this.state.passwordError}</p> */}
                                <div className="asr-edit-input">
                                  <input
                                    type="password"
                                    placeholder="New Password"
                                    id="pass2"
                                    onChange={(e) =>
                                      this.setState({
                                        newPassword: e.target.value,
                                      })
                                    }
                                    required
                                  />
                                </div>
                                {/* <p className="errormsg">
                                {this.state.passwordError}
                              </p> */}
                                <div className="asr-edit-input">
                                  <input
                                    type="password"
                                    placeholder="Confirm New Password"
                                    onChange={(e) =>
                                      this.setState({
                                        confirmPassword: e.target.value,
                                      })
                                    }
                                    required
                                  />
                                </div>
                                <p className="errormsg">
                                  {this.state.passwordError}
                                </p>
                                <div className="asr-edit-input">
                                  <button
                                    className="asr-edit-btn"
                                    type="submit"
                                  >
                                    {" "}
                                    {this.state.saveChangesLoading
                                      ? "loading..."
                                      : "Save Changes"}
                                  </button>
                                </div>
                                {/* <div className="load-gif2" id="load">
                                <img src={Load} alt="loading" />
                              </div> */}
                                <p className="successmsg2" id="successmsg">
                                  {this.state.successMsg}
                                </p>
                                <p className="errormsg3">
                                  {this.state.incorrectError}
                                </p>
                                <p className="errormsg3">
                                  {this.state.otherError}
                                </p>
                              </form>
                            </>
                          )}
                          {activeSection === "createPin" && (
                            <>
                              <p
                                style={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                  marginRight: "0.5rem",
                                  marginTop: "0.5rem",
                                  cursor: "pointer",
                                }}
                                onClick={this.handleSecurity}
                              >
                                <Close />
                              </p>

                              <form
                                id="cp-toggle"
                                className="asr-edit-form animate__animated animate__fadeIn"
                                onSubmit={this.handleCreatePinSubmit}
                              >
                                <h2>Create Pin</h2>
                                <div className="asr-edit-input">
                                  <input
                                    type="password"
                                    placeholder="New Pin"
                                    id="pin"
                                    onChange={(e) =>
                                      this.setState({ newPin: e.target.value })
                                    }
                                    required
                                    maxLength="6"
                                  />
                                </div>
                                <p className="errormsg">
                                  {this.state.passwordError}
                                </p>
                                <div className="asr-edit-input">
                                  <input
                                    type="password"
                                    placeholder="Confirm New Pin"
                                    id="pin2"
                                    onChange={(e) =>
                                      this.setState({
                                        confirmPin: e.target.value,
                                      })
                                    }
                                    required
                                    maxLength="6"
                                  />
                                </div>
                                <p className="errormsg">
                                  {this.state.passwordError}
                                </p>
                                <p className="errormsg">
                                  {this.state.pinError}
                                </p>
                                <div className="asr-edit-input">
                                  <button
                                    className="asr-edit-btn"
                                    disabled={this.state.pinSubmitLoading}
                                    type="submit"
                                  >
                                    {this.state.pinSubmitLoading
                                      ? "loading..."
                                      : "Create new Pin"}
                                  </button>
                                </div>

                                <p className="successmsg2" id="successmsg">
                                  {this.state.successMsg}
                                </p>
                                <p className="errormsg3">
                                  {this.state.incorrectError}
                                </p>
                                <p className="errormsg3">
                                  {this.state.otherError}
                                </p>
                              </form>
                            </>
                          )}

                          {activeSection === "changePin" && (
                            <>
                              <form
                                id="cp-toggle"
                                className="asr-edit-form animate__animated animate__fadeIn"
                                onSubmit={this.handleChangePinSubmit}
                              >
                                <h2>Change Pin</h2>
                                <div className="asr-edit-input">
                                  <input
                                    type="password"
                                    placeholder="Current Pin"
                                    id="pin0"
                                    onChange={(e) =>
                                      this.setState({
                                        currentPin: e.target.value,
                                      })
                                    }
                                    required
                                  />
                                </div>

                                <div className="asr-edit-input">
                                  <input
                                    type="password"
                                    placeholder="New Pin"
                                    id="pin"
                                    onChange={(e) =>
                                      this.setState({ newPin: e.target.value })
                                    }
                                    required
                                    maxLength="7"
                                  />
                                </div>
                                <p className="errormsg">
                                  {this.state.passwordError}
                                </p>
                                <div className="asr-edit-input">
                                  <input
                                    type="password"
                                    placeholder="Confirm New Pin"
                                    id="pin2"
                                    onChange={(e) =>
                                      this.setState({
                                        confirmPin: e.target.value,
                                      })
                                    }
                                    required
                                    maxLength="7"
                                  />
                                </div>
                                <p className="errormsg">
                                  {this.state.passwordError}
                                </p>
                                <div className="asr-edit-input">
                                  <button
                                    className="asr-edit-btn"
                                    type="submit"
                                  >
                                    Update Pin
                                  </button>
                                </div>
                                {/* <div className="load-gif2" id="load">
                                <img src={Load} alt="loading" />
                              </div> */}
                                <p className="successmsg2" id="successmsg">
                                  {this.state.successMsg}
                                </p>
                                <p className="errormsg3">
                                  {this.state.incorrectError}
                                </p>
                                <p className="errormsg3">
                                  {this.state.otherError}
                                </p>
                              </form>
                            </>
                          )}

                          {activeSection === "resetPin" && (
                            <form
                              id="cp-toggle"
                              className="asr-edit-form animate__animated animate__fadeIn"
                              onSubmit={this.getPinResetCode}
                            >
                              <h2>Reset Pin</h2>

                              <div className="asr-edit-input">
                                <input
                                  type="password"
                                  placeholder="New Pin"
                                  id="pin"
                                  onChange={(e) =>
                                    this.setState({
                                      newPin: e.target.value,
                                      oldPin: e.target.value,
                                    })
                                  }
                                  required
                                  maxLength="7"
                                />
                              </div>
                              <p className="errormsg">
                                {this.state.passwordError}
                              </p>
                              <div className="asr-edit-input">
                                <input
                                  type="password"
                                  placeholder="Confirm New Pin"
                                  id="pin2"
                                  onChange={(e) =>
                                    this.setState({
                                      confirmPin: e.target.value,
                                    })
                                  }
                                  required
                                  maxLength="7"
                                />
                              </div>
                              <p className="errormsg">
                                {this.state.passwordError}
                              </p>
                              <div className="asr-edit-input">
                                <button className="asr-edit-btn" type="submit">
                                  Reset Pin
                                </button>
                              </div>
                              {/* <div className="load-gif2" id="load">
                                <img src={Load} alt="loading" />
                              </div> */}
                              <p className="successmsg2" id="successmsg">
                                {this.state.successMsg}
                              </p>
                              <p className="errormsg3">
                                {this.state.incorrectError}
                              </p>
                              <p className="errormsg3">
                                {this.state.otherError}
                              </p>
                            </form>
                          )}
                          {activeSection === "confirmResetPin" && (
                            <form
                              id="cp-toggle"
                              className="asr-edit-form animate__animated animate__fadeIn"
                              onSubmit={this.handleResetPinSubmit}
                            >
                              <h2>Enter Reset Verification Code</h2>

                              <div className="asr-edit-input">
                                <input
                                  type="password"
                                  placeholder="Verification Code"
                                  id="pin"
                                  onChange={(e) =>
                                    this.setState({ resetCode: e.target.value })
                                  }
                                  required
                                  maxLength="7"
                                />
                              </div>
                              <p className="errormsg">
                                {this.state.resetCodeError}
                              </p>
                              <div className="asr-edit-input">
                                <button className="asr-edit-btn" type="submit">
                                  Reset Pin
                                </button>
                              </div>
                              {/* <div className="load-gif2" id="load">
                                <img src={Load} alt="loading" />
                              </div> */}
                              <p className="successmsg2" id="successmsg">
                                {this.state.successMsg}
                              </p>
                              <p className="errormsg3">
                                {this.state.incorrectError}
                              </p>
                              <p className="errormsg3">
                                {this.state.otherError}
                              </p>
                            </form>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
